import loginPage from '../components/loginPage.vue'
import detailPage from '@/modules/pass/components/detailPage.vue'
import editPage from '@/modules/pass/components/editPage.vue'
import downloadPage from '@/modules/pass/components/downloadPage.vue'

export default [
  {
    path: '/',
    redirect: '/detail',
    meta: {
      requiresLoggedIn: true
    }
  },
  {
    name: 'detail',
    path: '/detail',
    component: detailPage,
    meta: {
      requiresLoggedIn: true
    }
  },
  {
    name: 'edit',
    path: '/edit',
    component: editPage,
    meta: {
      requiresLoggedIn: true
    }
  },
  {
    name: 'download',
    path: '/download/:urlName',
    component: downloadPage,
    props: true
  },
  {
    name: 'login',
    path: '/login',
    component: loginPage,
    meta: {
      bodyClass: 'login-page'
    }
  }
]
